


















import { Component, Prop, Mixins } from "vue-property-decorator";
import { BaseBorderless } from "@share/common/form/form-controls/base/borderless/base-borderless";
import { StubInputBase } from "@share/common/form/form-controls/stub/stub-input-base";

@Component({})

export default class StubInputUserSelect extends Mixins(StubInputBase, BaseBorderless) {
    @Prop({ default: true }) enableToggle: boolean;
    @Prop() title: string | undefined;

    click() {
        this.enableToggle ? this.toggle() : this.focus();
    }

    toggle() {
        this.focused ? this.blur() : this.focus();
    }
}

